import React from "react";
import { AutoComplete, AutoCompleteProps } from "antd";

interface LabelInputProps extends AutoCompleteProps {
  title?: string;
  errorText?: boolean | string;
}

function AutoCompleteInput({ title, errorText, ...rest }: LabelInputProps) {
  return (
    <>
      {title && (
        <label
          style={{
            color: "#557EFF",
            fontSize: "14px",
            fontWeight: "500",
            marginBottom: "12px",
            display: "flex",
          }}
        >
          {title}
        </label>
      )}
      <AutoComplete
        style={{
          // height: "40px",
          ...(!errorText && {
            border: "1px solid #F3F3F3",
          }),
        }}
        status={!!errorText ? "error" : ""}
        {...rest}
      />
    </>
  );
}

export default AutoCompleteInput;
